// Script para personalizar a página de produto
document.addEventListener('DOMContentLoaded', function() {
  // Verificar se estamos em uma página de produto
  if (!document.querySelector('.template-product')) return;
  
  // Obter elementos principais
  const productContainer = document.querySelector('.product');
  const productTitle = document.querySelector('.product__title h1, .product__title .h1');
  const productPrice = document.querySelector('#price-main-product');
  const productForm = document.querySelector('product-form');
  const productDescription = document.querySelector('.product__description');
  const buyButton = document.querySelector('.product-form__submit');
  const productInfo = document.querySelector('.product__info-container');
  const mediaGallery = document.querySelector('.product__media-gallery');
  
  if (!productContainer) return;
  
  // Adicionar classe de layout personalizado
  productContainer.classList.add('product-custom-layout');
  
  // Customizar a galeria de imagens
  if (mediaGallery) {
    // Adicionar classe para estilização customizada
    mediaGallery.classList.add('media-gallery-custom');
    
    // Obter todas as imagens do produto
    const sliderDots = document.querySelectorAll('.slider-buttons .slider-counter__link');
    const mainImage = document.querySelector('.product__media-item');
    const slider = document.querySelector('.slider');
    
    if (sliderDots.length > 0 && mainImage && slider) {
      // Criar container para as miniaturas verticais
      const thumbnailContainer = document.createElement('div');
      thumbnailContainer.className = 'product-thumbnails-vertical';
      
      // Criar miniaturas para cada imagem do slider
      sliderDots.forEach((dot, index) => {
        // Encontrar a URL da imagem correspondente
        const slideId = `Slide-${mediaGallery.dataset.mediaId || 'template'}-${index + 1}`;
        const slideImage = document.querySelector(`#${slideId} img`);
        
        if (slideImage) {
          const thumbnail = document.createElement('div');
          thumbnail.className = 'product-thumbnail';
          if (index === 0) thumbnail.classList.add('active');
          
          const thumbImg = document.createElement('img');
          thumbImg.src = slideImage.src;
          thumbImg.alt = slideImage.alt;
          thumbImg.dataset.index = index;
          
          thumbnail.appendChild(thumbImg);
          thumbnailContainer.appendChild(thumbnail);
          
          // Adicionar evento de clique para trocar a imagem
          thumbnail.addEventListener('click', function() {
            // Remover classe ativa de todas as miniaturas
            document.querySelectorAll('.product-thumbnail').forEach(t => t.classList.remove('active'));
            // Adicionar classe ativa à miniatura clicada
            thumbnail.classList.add('active');
            // Simular clique no respectivo dot do slider
            sliderDots[index].click();
          });
        }
      });
      
      // Inserir o container de miniaturas antes do slider
      slider.parentNode.insertBefore(thumbnailContainer, slider);
      slider.parentNode.classList.add('gallery-with-thumbnails');
    }
  }
  
  // Criar container de abas
  const tabsContainer = document.createElement('div');
  tabsContainer.className = 'product-tabs';
  tabsContainer.innerHTML = `
    <div class="tabs-headers">
      <button class="tab-header active" data-tab="como-usar">como usar</button>
      <button class="tab-header" data-tab="composicao">composição</button>
      <button class="tab-header" data-tab="tempo-protecao">tempo de proteção</button>
      <button class="tab-header" data-tab="modo-uso">modo de uso</button>
    </div>
    
    <div class="tabs-content">
      <div class="tab-content active" id="como-usar">
        <p>Aplique o desodorante nas axilas secas e limpas.</p>
      </div>
      <div class="tab-content" id="composicao">
        <p>Blend de Gliceris, Álcool cetoestearílico, Óleo de coco, Bicarbonato de sódio, Óleos essenciais.</p>
      </div>
      <div class="tab-content" id="tempo-protecao">
        <p>Proteção de até 24 horas contra odores.</p>
      </div>
      <div class="tab-content" id="modo-uso">
        <p>Aplique uma pequena quantidade nas axilas após o banho.</p>
      </div>
    </div>
  `;
  
  // Adicionar as abas após o formulário do produto
  if (productInfo) {
    productInfo.appendChild(tabsContainer);
  }
  
  // Estilizar o botão de compra
  if (buyButton) {
    buyButton.classList.add('custom-buy-button');
    buyButton.innerText = 'comprar agora';
  }
  
  // Lógica para trocar entre as abas
  const tabHeaders = document.querySelectorAll('.tab-header');
  const tabContents = document.querySelectorAll('.tab-content');
  
  tabHeaders.forEach(header => {
    header.addEventListener('click', function() {
      // Remover classe ativa de todas as abas
      tabHeaders.forEach(h => h.classList.remove('active'));
      tabContents.forEach(c => c.classList.remove('active'));
      
      // Adicionar classe ativa à aba clicada
      header.classList.add('active');
      const tabId = header.getAttribute('data-tab');
      document.getElementById(tabId).classList.add('active');
    });
  });
  
  // Ajustar o layout do seletor de quantidade
  const quantitySelector = document.querySelector('.product-form__quantity');
  if (quantitySelector) {
    quantitySelector.classList.add('custom-quantity');
  }
});
